<template>
  <router-view v-if="cssloaded"></router-view>
</template>

<script>
export default {
  data() {
    return {
      cssloaded: false,
    }
  },
  mounted() {
    // EN production : Ajout du style dédié au domaine + affichage router uniquement si chargé
    switch (process.env.NODE_ENV) {
      case 'development':
        // RAS
        this.cssloaded = true

        break
      default:
        const subdomain = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false
        var link = document.createElement('link')
        // set the attributes for link element
        link.rel = 'stylesheet'
        link.type = 'text/css'
        link.href = '/domain-css/' + subdomain + '.css'
        // Append link element to HTML head
        document.getElementsByTagName('HEAD')[0].appendChild(link)
        // On laisse le temps au dom de se rendre avec le nouveau CSS
        setTimeout(() => {
          this.cssloaded = true
        }, 300)
        break
    }
  },
}
</script>
